import { RouteConfig } from "vue-router";
import { LinksConstrains } from "@/enums/links.enum";
import { AppsConstraints } from "@/enums/apps.enum";

const routes: Array<RouteConfig> = [
  {
    path: LinksConstrains.CALL_CENTER_ORDERS,
    name: "menu.today_orders",
    component: () => import("./index.vue"),
    meta: { isAuth: true, title: "POSRocket | Orders", app: AppsConstraints.CALL_CENTER },
  },

  {
    path: LinksConstrains.CALL_CENTER_CREATE_ORDER,
    name: "create_order",
    component: () => import("./index.vue"),
    meta: { isAuth: true, title: "POSRocket | Create Orders", app: AppsConstraints.CALL_CENTER },
  },

  {
    path: LinksConstrains.CALL_CENTER_EDIT_ORDER,
    name: "call_center_edit_order",
    component: () => import("./index.vue"),
    meta: { isAuth: true, title: "POSRocket | Edit Orders", app: AppsConstraints.CALL_CENTER },
  },

  {
    path: "/call-center/orders/dummy",
    name: "dummy order",
    component: () => import("./dummy/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Dummy Orders", app: AppsConstraints.CALL_CENTER },
  },
];

export default routes;
